import Cookies from "js-cookie";

const sessionCookieNames = [
  "status",
  "env",
  "token",
  "userId",
  "userRole",
  "userType",
  "timeOut",
  "businessUnit",
  "expiryDateTime",
  "userName",
  "refreshToken",
  "tokenUserName",
  "picture",
  "lastActiveTime",
];

export const removeAllCookies = () => {
  // Session cookies are set with Secure. A remove without that attribute does not
  // replace them on HTTPS, so the admin session survives the invite page.
  for (const name of sessionCookieNames) {
    Cookies.remove(name, { path: "/" });
    Cookies.remove(name, { path: "/", secure: true });
  }
};
